/**
 * @file   src\components\MemberWantAd\ShareMyWantAdSmallModal.js
 * @brief  This file is responsible for want ad creation success modal.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import FireWorkImgTop from "../../images/party-popper.png";

const ShareMyWantAdSmallModal = (props) => {
  const { show, onHide, showShareModalPopup } = props;
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-custom-width"
    >
      <Modal.Body className="pt-100 pb-32">
        <div className="fireworks-overlay-top">
          <div className="pyro pyro-left-top">
            <div className="before"></div>
            <div className="after"></div>
          </div>
          <img
            className="mw-48"
            src={FireWorkImgTop}
            width={"48px"}
            height={"48px"}
          />
        </div>

        <button
          type="button"
          className="btn-close"
          onClick={() => onHide()}
        ></button>
        <h3 className="text-center mt-0">Your want-listing looks great!</h3>

        <Row>
          <Col xl={12} className="">
            <p className=" mb-4 f-size-16 text-center">
              Be on the lookout for introductions from members who want you to
              view their property. You'll decide if it's a good match.
            </p>
          </Col>
          <Col xl={12} className="">
            <div className="modal-btn-wrap">
              <Button
                variant="primary"
                className="btn w-100"
                onClick={() => showShareModalPopup()}
              >
                Share My Listing
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default ShareMyWantAdSmallModal;
